import EventModel from '../EventModel';

import CartInfoModel from './models/CartInfoModel';
import UserInfoModel from './models/UserInfoModel';
import WishlistInfoModel from './models/WishlistInfoModel';
import {EEventSource, IEventData} from 'coreClasses/events/IEvents';
import {EGoogleTagManagerEventSource} from '../../IGoogleTagManager';
import ManagerRepository from 'coreClasses/ManagerRepository';
import LocaleModel from 'coreClasses/locales/LocaleModel';
import SeoMgr from 'coreClasses/seo/SeoMgr';
import {MessageDescriptor} from 'react-intl';

/**
 * Represents PageViewEventModel
 */
export default class PageViewEventModel extends EventModel {
	public gtmContainerID: string;
	public URI: string;
	public cartInfo: CartInfoModel;
	public currencyCode: string;
	public pageType: string;
	public site_section: string;
	public userInfo: UserInfoModel;
	public wishlistInfo?: WishlistInfoModel;
	public locale: string;
	public path: string;
	public location: string;
	public templateName: string;
	public title: string | MessageDescriptor;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		const customer = data.customer;
		const wishlist = data.wishlist;
		const currentLocale: LocaleModel = this.managerRepository.getLocalesMgr().getCurrentLocale();
		const pageType = EGoogleTagManagerEventSource[EEventSource[data.pageType]];
		const seo: SeoMgr = this.managerRepository.getSeoMgr();

		this.gtmContainerID = data.configuration.containerId;
		this.URI = data.uri;
		this.cartInfo = data.basket && new CartInfoModel(managerRepository, data.basket);
		this.currencyCode = currentLocale.getCurrencyCode();
		this.pageType = pageType || EGoogleTagManagerEventSource.OTHER;
		this.userInfo = customer && new UserInfoModel(managerRepository, customer);
		this.locale = data.locale;
		this.path = data.uri;
		this.location = location.href;
		this.templateName = pageType || EGoogleTagManagerEventSource.OTHER;
		this.title = seo.getMetadata().title;

		//include key as long as property exists in data from DG, even if undefined
		if (Object.hasOwn(data, 'siteSection')) {
			this.site_section = data.siteSection;
		}

		if (customer?.isRegistered && !wishlist?.isEmpty) {
			this.wishlistInfo = new WishlistInfoModel(managerRepository, data.wishlist);
		}
	}

	/**
	 * Checks if event is persistent
	 * @returns {boolean} true if event is persistent
	 */
	public isPersistentEvent() {
		return true;
	}

	/**
	 * Checks if the event should be kept
	 * @param {any} previousEvent - the previous event
	 * @returns {boolean} true if event should be kept
	 */
	public isEventShouldBeKept(previousEvent: any): boolean {
		return previousEvent.URI === this.URI && previousEvent.pageType === this.pageType;
	}
};
